var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerPratice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 4.30273C6.01706 4.30273 2.77539 7.5444 2.77539 11.5277C2.77539 15.5111 6.01706 18.7611 10.0004 18.7611C13.9837 18.7611 17.2254 15.5194 17.2254 11.5361C17.2254 7.55273 13.9837 4.30273 10.0004 4.30273ZM10.6254 11.2611C10.6254 11.6027 10.3421 11.8861 10.0004 11.8861C9.65872 11.8861 9.37539 11.6027 9.37539 11.2611V7.0944C9.37539 6.75273 9.65872 6.4694 10.0004 6.4694C10.3421 6.4694 10.6254 6.75273 10.6254 7.0944V11.2611Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4079 3.30272H7.59121C7.25788 3.30272 6.99121 3.03606 6.99121 2.70272C6.99121 2.36939 7.25788 2.09439 7.59121 2.09439H12.4079C12.7412 2.09439 13.0079 2.36106 13.0079 2.69439C13.0079 3.02772 12.7412 3.30272 12.4079 3.30272Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerPratice);
export default __webpack_public_path__ + "static/media/timer-pratice.e728b23eb16bf9b91db6ed45060ed132.svg";
export { ForwardRef as ReactComponent };